export const displayJsonError = json => {
  if (json && json.message) {
    return json.message;
  }

  return 'Une erreur technique est survenue';
};

export const displayError = (error: Error) => {
  if (error.json) return displayJsonError(error.json);
  else {
    return 'Une erreur technique est survenue';
  }
};



// WEBPACK FOOTER //
// ./src/utils/errors.js